import { p as proxyCustomElement, H, h, c as Host } from './p-DWmaQhSz.js';

/*!
 * Planning Center Tapestry Web Components
 * Version: 1.3.0
 */

const SidenavResponsiveHeader = /*@__PURE__*/ proxyCustomElement(class SidenavResponsiveHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        /** Whether the sidenav is open */
        this.isOpen = false;
    }
    // --------------------------------------------------------------------------
    //
    //  Lifecycle
    //
    // --------------------------------------------------------------------------
    componentWillLoad() {
        var _a;
        const parentNavId = (_a = this.el.closest("nav")) === null || _a === void 0 ? void 0 : _a.id;
        if (!parentNavId) {
            throw new Error("Sidenav header must be a child of a nav element");
        }
        this.popoverId = `${parentNavId}-popover`;
    }
    componentDidLoad() {
        const popoverElement = document.getElementById(this.popoverId);
        popoverElement === null || popoverElement === void 0 ? void 0 : popoverElement.addEventListener("toggle", (event) => {
            this.isOpen = event.newState === "open";
        });
    }
    // --------------------------------------------------------------------------
    //
    //  Render Methods
    //
    // --------------------------------------------------------------------------
    render() {
        return (h(Host, { key: 'fb205b5346252cb86107be62bfa065980d1e9267', class: "tds-sidenav-responsive-header" }, this.label && (h("h2", { key: '86f15574cd074cdc3ddaefcc3846ebb9ae5c7942', class: "tds-sidenav-responsive-header-label" }, this.label)), h("button", { key: '93468fe17f8a0d3de48c0869b6505b18524d7f9a', type: "button", class: "tds-sidenav-responsive-header-toggle", "aria-label": this.isOpen ? "Close menu" : "Open menu", "aria-controls": this.popoverId, popoverTarget: this.popoverId }, h("svg", { key: 'a46f509df7d7f2481ead2c339b4f8076d88a0e20', xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" }, h("path", { key: '16ece7fe047cca488aaa9265a31b68397056e859', d: "M0 6.91104H16V8.68904H0V6.91104ZM0 13.133H16V11.356H0V13.133ZM0 2.46704V4.24404H16V2.46704H0Z", fill: "currentColor" })))));
    }
    get el() { return this; }
}, [2, "tds-sidenav-responsive-header", {
        "label": [1],
        "isOpen": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["tds-sidenav-responsive-header"];
    components.forEach(tagName => { switch (tagName) {
        case "tds-sidenav-responsive-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SidenavResponsiveHeader);
            }
            break;
    } });
}

export { SidenavResponsiveHeader as S, defineCustomElement as d };
//# sourceMappingURL=p-CDGub1VX.js.map
